import 'styles/index.scss'

import { useEffect } from 'react'
import DataUniversRoute from 'routes/index'
import Footer from 'shared/components/layout/Footer'
import Header from 'shared/components/layout/Header'

const App = () => {
  // if (process.env.NODE_ENV === 'development') {
  //   console.log = function no_console() {}
  // }

  useEffect(() => {
    const userAgent = navigator.userAgent
    if (!userAgent.includes('react-hydratable')) {
      const rootElement = document.getElementById('root')
      if (rootElement) {
        rootElement.classList.add('display_root')
      }
    }
  }, [])

  return (
    <>
      <Header />
      <DataUniversRoute />
      <Footer />
    </>
  )
}

export default App
